/* global axios */
import ApiClient from './ApiClient';

class DigitalHumansAPI extends ApiClient {
  constructor() {
    super('digital_humans', { accountScoped: true });
  }

  updateWithInboxes(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  createWithInboxes(data) {
    return axios.post(this.url, data);
  }

  testIntegration(id, { api_key, base_url }) {
    return axios.post(`${this.url}/${id}/test_integration`, { api_key, base_url });
  }
}

export default new DigitalHumansAPI();
